import React, { FunctionComponent, RefObject } from 'react';
import { MenuItem } from '../MenuUtils';
import Select from 'react-select';
import { ValueType } from 'react-select/lib/types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

interface Props {
  item: MenuItem;
  thematicsFilter?: string;
  setThematicsFilter: (filter: string) => void;
  parentRef: RefObject<HTMLDivElement>;
}
interface Option {
  value: string;
  label: string;
}

export const MenuThematicsOptions: FunctionComponent<Props> = ({ item, setThematicsFilter, thematicsFilter, parentRef }) => {
  const { t } = useTranslation('sharedComponents');
  const allItemsFilterValues = item.children?.map(item => item.thematicFilters ?? []) ?? [];
  const allValues = ([] as string[]).concat(...allItemsFilterValues);

  // If no values available for filtering, we don't display the SelectBox
  if (allValues.length == 0) {
    return null;
  }

  const uniqueValues = [...new Set(allValues)];
  uniqueValues.sort();
  const options: Option[] = [{ label: t('shared.menu.seeAll'), value: '' }, ...uniqueValues.map(item => ({ value: item, label: item }))];

  const handleChange = (option: ValueType<Option>) => {
    if (option == undefined) return;
    const selected = option as Option;
    setThematicsFilter(selected.value);
  };

  return (
    <StyledContainer>
      <StyledThematicOptionsLabel>{t('shared.menu.filter')}</StyledThematicOptionsLabel>
      <StyledSelectContainer>
        <label>
          <span>Label wrapping Select</span>
          <Select
            options={options}
            value={options.find(item => item.value === thematicsFilter)}
            onChange={handleChange}
            isSearchable={false}
            styles={{
              menuPortal: base => ({ ...base, zIndex: 13000 }),
              control: base => ({ ...base, backgroundColor: '#f5f5f5', borderRadius: '25px', padding: '5px', border: 'none', fontSize: '12px' }),
              dropdownIndicator: base => ({ ...base, color: '#333' })
            }}
            components={{ IndicatorSeparator: () => null }}
            menuPortalTarget={parentRef.current}
            className={'not-uniform'}
          />{' '}
        </label>
      </StyledSelectContainer>
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  display: flex;
  text-transform: none;
  align-items: center;
  margin-bottom: 20px;
  label > span {
    display: none;
  }
`;

const StyledThematicOptionsLabel = styled.div`
  font-size: 12px;
  color: #bbb;
`;

const StyledSelectContainer = styled.div`
  flex: 1;
  margin-left: 5px;
  margin-right: 2px;
  width: 10px !important;
  input {
    width: 1px !important; //Here to prevent AMS global input style to prevail
  }
`;
